module.exports = __webpack_public_path__ + "static/changeling_near_mirror-c680835e48d992787a86b251ad74bae2.webp";